import $ from 'jquery'
import Swiper from 'swiper'

$('.menu-horizontal-swiper').each(function() {
    let swiper = new Swiper(this, {
        slidesPerView: 'auto',
        freeMode: true,
        watchOverflow: true,
    })
})